import React from "react";
import productImage from "../assets/15.jpeg";
import PageHero from "../components/PageHero";

const About = () => (
  <div className="w-full">
    <PageHero
      eyebrow="About Zea Mays"
      title="Nigerian food products with purpose."
      description="Zea Mays Foods is a food processing, nutrition, and wellness company focused on quality food products, local ingredients, customer satisfaction, and positive community impact."
      image={productImage}
      imageAlt="Zea Mays Nigerian food products"
      primaryAction={{ to: "/products", label: "Shop Products" }}
      secondaryAction={{ to: "/contact", label: "Contact Us" }}
      stats={[
        { label: "Food products", value: "Quality focused" },
        { label: "Local sourcing", value: "Community minded" },
        { label: "Food choices", value: "Nourishing" },
        { label: "Local brand", value: "Ikorodu" },
      ]}
      compact
    />
    <div className="min-h-screen w-full bg-green-100 px-6 py-16">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-2">
        <div className="text-center lg:text-left">
          <p className="text-sm font-semibold uppercase tracking-[0.28em] text-red-700">Our story</p>
          <h1 className="mb-6 mt-3 text-4xl font-extrabold text-slate-950 md:text-5xl">
            Food processing, nutrition, and wellness for everyday life.
          </h1>
          <p className="text-lg leading-relaxed text-slate-700 md:text-xl">
            Zea Mays Foods makes quality Nigerian food products from locally sourced ingredients,
            helping customers make convenient and informed food choices at fair price points.
            Our work is inspired by Nigerian food traditions and strengthened by thoughtful,
            modern food processing.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-slate-700 md:text-xl">
            Our philosophy is <strong className="text-red-800">Eat to Thrive</strong>: making food
            part of a practical, nourishing lifestyle while celebrating local ingredients and
            supporting community development.
          </p>
          <div className="mt-8 grid gap-4 sm:grid-cols-3">
            {[
              ["Food processing", "Carefully prepared pantry staples and Nigerian food products."],
              ["Nutrition and wellness", "Food choices designed to support everyday wellbeing."],
              ["Agribusiness", "A growing focus on local sourcing and responsible partnerships."],
            ].map(([title, text]) => (
              <div key={title} className="rounded-2xl border border-lime-200 bg-white p-4 shadow-sm">
                <h2 className="font-bold text-red-800">{title}</h2>
                <p className="mt-2 text-sm leading-6 text-slate-600">{text}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-center lg:justify-end">
          <div className="w-full max-w-xl overflow-hidden rounded-3xl bg-white p-3 shadow-lg">
            <img
              src={productImage}
              alt="Quality Zea Mays Nigerian food product"
              className="h-full max-h-[520px] w-full rounded-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default About;
